import { render, staticRenderFns } from "./defaultFreightTemplate.vue?vue&type=template&id=644ce032&"
import script from "./defaultFreightTemplate.vue?vue&type=script&lang=js&"
export * from "./defaultFreightTemplate.vue?vue&type=script&lang=js&"
import style0 from "./defaultFreightTemplate.vue?vue&type=style&index=0&id=644ce032&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports